import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AlertNoticeModel } from 'data/alert/alert.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: AlertNoticeModel[];
  error: any;
};

const initState: SliceState = {
  status: 'idle',
  data: [],
  error: false,
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<AlertNoticeModel[]>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const alertSlice = createSlice({
  name: 'alert',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default alertSlice;
